export const formConstants = {
  FORM_INIT: 'FORM_INIT',
  TERMINATE_FORM: 'TERMINATE_FORM',
  FIELD_CHANGED: 'FIELD_CHANGED',
  FORM_MERGE: 'FORM_MERGE',
};
